import { Helper } from "../core/util/helper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { Config as config } from "../core/config/config";
import { AppHelper } from "../appHelper";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { Entity } from "../core/components/commonApp";
import React from "react";
export default class InheritedValueComment extends React.Component<InheritedValueCommentProps, any> {
    common = new AppHelper();
    sheet: Sheet;
    resetClick = () => {
        this.sheet.trigger(SheetEventType.Custom, 
            { command: "reset", field: this.props.fieldModel});
    }

    constructor(props: InheritedValueCommentProps) {
        super(props);
        this.sheet = General.Sheet.Manager.getTopMostVisibleSheet();
        this.common.init(this);
    }

    render() {
        let implicit = false;
        let text: string;
        let linkText: string = null;
        let match = this.props.fieldModel.match(/^(entity(?:\.TaskGroup)?)\.(?:Merged|Explicit)(\w+)\.(\w+)$/);
        if (match) {
            let parentValueModel = `${match[1]}.Parent${match[2]}.${match[3]}`;
            let explicitValueModel = `${match[1]}.Explicit${match[2]}.${match[3]}`;
            let parentValue = MetaDataHelper.getFieldValue(this.props.entity, parentValueModel);
            let explicitValue = MetaDataHelper.getFieldValue(this.props.entity, explicitValueModel);
            let textLeft: string;
            let textRight: string = "";
            if (Helper.isNullOrEmpty(explicitValue)) {
                text = config.translations.valueFromParent;
                textLeft = text;
            }
            else {
                let dateValue = kendo.parseDate(parentValue);
                if (parentValue == null)
                    parentValue = Helper.getTranslation("Statistik.IN_OVERVIEW_EVENTS.NoValue");
                else if(dateValue != null)
                    parentValue = kendo.toString(dateValue, 'd');
                    
                let readonly = this.common.tryEvalAction(this.props.readOnly);
                if (readonly) {
                    text = config.translations.valueFromParentOverridden.replace("{value}", parentValue);
                    textLeft = text;
                }
                else {
                    text = config.translations.valueFromParentWithAction.replace("{value}", parentValue);
                    textLeft = text;
                    let linkMatch = text.match(/<a>(.*)<\/a>/);
                    if (linkMatch) {
                        linkText = linkMatch[1];
                        textLeft = text.substring(0, linkMatch.index);
                        textRight = text.substring(linkMatch.index + linkMatch[0].length);
                    }
                    implicit = true;
                }
            }

            if (!Helper.isNullOrEmpty(text)) {
                const link = implicit && Helper.hasValue(linkText) ? <a onClick={() => this.resetClick()}>{linkText}</a> : null;
                return (
                    <div style={this.props.divStyle} className="fieldComment">
                        <label style={this.props.labelStyle} className="fieldComment__label">&lt;{textLeft}{link}{textRight}&gt;</label>
                    </div>
                );
            } else {
                return (<></>);
            }
        }
        else
            return null;
    };
}

interface InheritedValueCommentProps {
    entity: Entity;
    readOnly: string;
    fieldModel: string;
    labelStyle?: React.CSSProperties;
    divStyle?: React.CSSProperties;
    field?: {
        text?: string;
        labelStyle?: React.CSSProperties;
        divStyle?: React.CSSProperties;
    }
}
